<template>
    <v-tooltip v-bind="settings" color="primary" max-width="200" :disabled="disableTooltip">
        <template v-slot:activator="{ on }">
            <v-avatar v-on="on"
                      :size="avatarSize"
                      color="grey darken-1"
            >
                <img class="ma-0" v-if="imageUrl" :src="imageUrl" alt="avatar">

                <div v-else>
                    <v-icon v-if="!initials" class="ma-0">{{ missingIcon }}</v-icon>

                    <span v-else class="font-weight-bold grey--text text--lighten-1">
                        {{ initials }}
                    </span>
                </div>
            </v-avatar>

        </template>
        <div v-if="!hasDefaultSlot">
            {{ personName ? personName : ''}}
        </div>
        <div v-else>
            <slot></slot>
        </div>
    </v-tooltip>
</template>

<script>

export default {

    components: {},

    props: {
        personName: {
            type: String | null,
            required: false,
        },
        imageUrl: {
            type: String | null,
            required: false,
            default: null
        },
        large: {
            type: Boolean,
            required: false,
            default: false
        },
        size: {
            type: Number,
            required: false,
        },
        missingIcon: {
            type: String,
            required: false,
            default: 'mdi-account'
        },
        disableTooltip: {
            type: Boolean,
            required: false,
            default: false,
        },
        tooltipDirection: {
            type: String,
            required: false,
            default: 'top'
        },
    },

    computed: {

        settings() {
            let settings = {};
            settings[this.tooltipDirection] = true;
            return settings;
        },

        initials() {
            if (this.personName) {
                let parts = this.personName.split(' ');

                let lastChar = '';
                let firstChar = '';

                if (parts.length > 0) {
                    lastChar = parts.pop()[0];
                }
                if (parts.length > 0) {
                    firstChar = parts.pop()[0];
                }
                return firstChar + lastChar;
            }

            return null;
        },

        avatarSize() {
            if (this.size) return this.size;
            return this.large ? 45 : 35;
        },

        hasDefaultSlot() {
            return !!this.$slots.default
        },
    },
}
</script>
